module.exports = __webpack_public_path__ + "static/media/blog-1.6b19c401.jpg";